<template>
    <div class="payments-history-tab" ref="tab">
        <el-table
                :data="historyData"
                v-loading="isLoading"
                style="width: 100%">

            <el-table-column
                    label="Number"
                    max-width="200"
                    align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.number }}</span>
                </template>
            </el-table-column>


            <el-table-column
                    label="Plan name"
                    min-width="200"
                    align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.plan_name }}</span>
                </template>
            </el-table-column>

            <el-table-column
                    label="Total"
                    max-width="100"
                    align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.total }}</span>
                </template>
            </el-table-column>

            <el-table-column
                    label="Status"
                    max-width="100"
                    align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.status }}</span>
                </template>
            </el-table-column>

            <el-table-column
                    label="Date"
                    width="200"
                    align="center">
                <template slot-scope="scope">
                    <span style="margin-left: 3px">{{getDateEDTFormat(scope.row.date)}}</span>
                </template>
            </el-table-column>



            <el-table-column
                    label="PDF"
                    align="center">
                <template slot-scope="scope">
                    <a :href="scope.row.invoice_pdf">
                        <el-button
                                size="mini"
                                type="danger">
                                    PDF
                        </el-button>
                    </a>
                </template>
            </el-table-column>
        </el-table>

        <div v-if="hasMore" class="show-more">
            <el-button
                size="medium"
                @click="prependInvoices"
                :loading="prepend">
                Show more
            </el-button>
        </div>

    </div>
</template>

<script>
import request from '../../../servises/request';
import html2canvas from 'html2canvas';

  export default {
    name: 'PaymentsHistory',
    props: {
      isScreenProcess: Boolean,
      isPaymentHistoryScreenProcess: Boolean,
      screenshotPage: HTMLDivElement
    },
    data() {
        return {
            isLoading: true,
            hasMore:false,
            prepend: false,
            next:null,
            historyData: []
        }
    },
    created() {
      this.getData().then(resolve=>{
        if (this.isScreenProcess) {
            this.createCanvas();
        }
      })
    },

    methods:{
        prependInvoices(){
            this.prepend = true;
            this.getData()
        },
       async createCanvas () {
         this.screenshotPage.style.overflow = 'visible';
         this.screenshotPage.style.height = 'auto';
         const canvas = await html2canvas(this.screenshotPage, {
           scrollX: 0,
           scrollY: -window.scrollY,
           width: this.screenshotPage.offsetWidth,
           height: this.screenshotPage.scrollHeight,
         });
         const imgURL = {
           url: canvas.toDataURL('image/png'),
           name: 'Payment History',
         };

         this.$emit('addNewImage', imgURL);
         this.$emit('toggleUserLog');
         this.$emit('triggerNextTab', 'userLog');
      },
       async getData() {
           let next = this.hasMore ? '?next='+this.next : '';
            const invoices = await request({
                url: `/user/${this.$route.params.id}/invoices`+next,
                method: 'GET'
            })
            this.historyData = [...this.historyData, ...invoices.data];
            this.hasMore = invoices.pagination.has_more
            this.next = invoices.pagination.next
            this.isLoading = false;
            this.prepend = false;
            return Promise.resolve(true);
      },
      getDateEDTFormat(date) {
        if(!date) {
          return
        }

        const options = {
          timeZone: 'America/New_York',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        };

        return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
      }
    }
  }
</script>

<style lang="scss">
    .payments-history-tab {
        width: 98%;
        margin: 0 auto;
    }
    .pdf-btn {
        display: inline-block;
    }
    .pdf-btn .el-button {
        box-sizing: border-box;
        height: 28px;
        margin-left: 10px;
    }

    .show-more {
        margin: 20px;
        display: flex;
        justify-content: center;
    }
</style>
